// Copyright (c) StrangeBee 2024

import { QuerySelector } from 'thehive-sdk';

export const computeListSelector = (): QuerySelector => ({
    head: [{ name: 'listFunction' }],
    name: 'get-all-functions',
    sort: ['+name'],
});

export const computeOneSelector = ({ objectID }: { objectID: string }): QuerySelector => ({
    head: [{ name: 'getFunction', idOrName: objectID }],
    name: `get-functions-${objectID}`,
});
